module.exports = __webpack_public_path__ + "media/images/gallery/constellations/names_layer_on-0e70510bcd9e5769c1bbab63fda0da2d.png";